import createReducer from '../createReducer'
import {
  RECOVER_PASSWORD,
  RECOVER_PASSWORD_SUCCESSFUL,
  RECOVER_PASSWORD_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILURE
} from './constants'

const initialState = {
  isSubmiting: false,
  isSuccess: false,
  login: undefined,
  userPhrase: undefined
}

const auth = createReducer(initialState, {
  [RECOVER_PASSWORD]: (state, action) => ({
    ...initialState,
    login: action.payload.login,
    isSubmiting: true
  }),
  [RECOVER_PASSWORD_SUCCESSFUL]: (state, action) => ({
    ...state,
    isSubmiting: false,
    userPhrase: action.payload.userPhrase
  }),
  [RECOVER_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isSubmiting: false
  }),
  [RESET_PASSWORD]: (state, action) => ({
    ...state,
    isSubmiting: true,
    isSuccess: false
  }),
  [RESET_PASSWORD_SUCCESSFUL]: (state, action) => ({
    ...state,
    isSubmiting: false,
    isSuccess: true
  }),
  [RESET_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isSubmiting: false,
    isSuccess: false
  })
})

export default auth
